import FlexBox from '@component/FlexBox/FlexBox';
import styled from 'styled-components';

export const ModuleContainer = styled(FlexBox.Column)`
  padding: 12px;
  gap: 4px;
  border-radius: 4px;
`;
